import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Main = styled.div<{ collapsed: boolean }>`
  margin-left: ${({ collapsed }) => (collapsed ? '70px' : '450px')};
  width: calc(100% - ${({ collapsed }) => (collapsed ? '70px' : '450px')});
  transition: margin-left 0.3s ease, width 0.3s ease;
`;

export const Content = styled.main`
  padding: 20px;
  margin-top: 60px;
  /* max-width: 1600px; */
  width: 100%;

  margin: 60px auto;
`;

export const ToggleButton = styled.button<{ collapsed: boolean }>`
  position: absolute;
  top: 20px;
  left: ${({ collapsed }) => (collapsed ? '80px' : '260px')};
  z-index: 1000;
  border-radius: 4px;
  padding: 4px 8px;
  transition: left 0.3s ease;
  background: transparent;
  color: #57069e;
  border: none;
  cursor: pointer;
  transition: left 0.3s ease;
`;
